import React from 'react';

/** Blue circular check — border rgba(0,227,255,0.5), check #00e3ff */
export const CheckCircleIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={`shrink-0 w-6 h-6 sm:w-[1.4rem] sm:h-[1.4rem] ${className}`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="10" cy="10" r="8.25" stroke="rgba(0,227,255,0.5)" strokeWidth={1} />
    <path
      d="M6 10.25 8.5 12.75 14 7.25"
      stroke="#00e3ff"
      strokeWidth={1.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
